import { Cog, Users, Target, Globe } from 'lucide-react';

const About = () => {
  const features = [
    {
      icon: <Cog className="h-8 w-8 text-primary-600 dark:text-white" />,
      title: "FabLab de Pointe",
      description: "FabLab de pointe avec ateliers de fabrication numérique, imprimantes 3D, systèmes de découpe laser CNC, outils de robotique et équipements électroniques, combinés avec un accompagnement personnalisé pour transformer les idées en prototypes tangibles."
    },
    {
      icon: <Users className="h-8 w-8 text-blue-600 dark:text-white" />,
      title: "Workshops et Formation",
      description: "Programmes d'apprentissage pratique, bootcamps intensifs et clubs thématiques pour tous niveaux et tous âges."
    },
    {
      icon: <Target className="h-8 w-8 text-purple-600 dark:text-white" />,
      title: "Innovation Inclusive",
      description: "Espace ouvert favorisant la collaboration entre étudiants, startups, artisans et entreprises locales."
    },
    {
      icon: <Globe className="h-8 w-8 text-cyan-600 dark:text-white" />,
      title: "Impact Régional",
      description: "Hub de référence pour l'innovation créative et la transformation numérique en Afrique du Nord."
    }
  ];

  return (
    <section id="about" className="py-20 bg-white dark:bg-gray-900 relative">
      <div className="absolute inset-0 bg-[linear-gradient(rgba(0,0,0,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,0.02)_1px,transparent_1px)] dark:bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:100px_100px]"></div>
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-6">
            À Propos Fab43
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="group bg-white/80 dark:bg-white/5 backdrop-blur-sm rounded-xl p-8 border border-gray-200 dark:border-white/10 hover:bg-white/90 dark:hover:bg-white/10 hover:border-gray-300 dark:hover:border-white/20 transition-all duration-500 transform hover:-translate-y-2 shadow-sm"
            >
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 p-3 bg-primary-100 dark:bg-white/10 rounded-lg group-hover:bg-primary-200 dark:group-hover:bg-white/20 transition-all duration-300 group-hover:rotate-12">
                  {feature.icon}
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">{feature.title}</h3>
                  <p className="text-gray-600 dark:text-white/70 leading-relaxed">{feature.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        {/*
        <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 md:p-12 text-white text-center border border-white/10">
          <h3 className="text-3xl font-bold mb-6">Notre Mission</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <h4 className="text-xl font-semibold mb-3">Démocratiser</h4>
              <p className="text-white/70">L'accès aux technologies de fabrication numérique pour tous</p>
            </div>
            <div>
              <h4 className="text-xl font-semibold mb-3">Accompagner</h4>
              <p className="text-white/70">La montée en compétences et l'innovation locale</p>
            </div>
            <div>
              <h4 className="text-xl font-semibold mb-3">Connecter</h4>
              <p className="text-white/70">Les communautés créatives et entrepreneuriales</p>
            </div>
          </div>
        </div>
        */}
      </div>
    </section>
  );
};

export default About;